
















import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Photo } from '~/models'
import ImagesGallery from '~/components/shared/imagesGallery.vue'

@Component({
  components: {
    ImagesGallery,
  },
})
export default class MapCardAmenity extends Vue {
  @Prop({ default: null }) name: string
  @Prop({ default: null }) description: string
  @Prop({ default: (): Photo[] => [] }) photos: Photo[]

  get images() {
    return this.photos.map((photo) => photo.source || photo.url)
  }
}
